// AI Generated Test
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PagesTabsHelper } from '@client/app/blocks/helpers/pages-tabs.helper';
import { ParamService } from '@monsido/core/param/param.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-overview',
    templateUrl: './pages-overview.component.html',
    standalone: false,
})
export class PagesOverviewComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    subheaderTranslation: string = '';
    eventId: number = 0;
    issues: any[] = [];
    pages: any = [];
    tabs: any[] = [];
    promise: any = null;

    override currentSort: { direction: 'asc' | 'desc', by: string } = {
        by: 'priority_score',
        direction: 'desc',
    };

    constructor (
        private pageRepoService: PageRepoService,
        private translateService: TranslateService,
        private pagesTabsHelper: PagesTabsHelper,
        private paramService: ParamService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.initializeComponent();
    }

    ngOnDestroy (): void {
        this.onDestroy();
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initializeComponent (): void {
        this.subheaderTranslation = '';
        this.issues = [];
        this.pages = [];

        // Get tabs from helper
        this.tabs = this.pagesTabsHelper.getTabs();
        this.activeTab = this.pagesTabsHelper.getActiveTab() || 'all';

        this.loadLocations();
    }

    loadLocations (): void {
        const search = this.urlService.search();
        this.search = search.search as string || '';
        this.currentSort.by = search.sort_by as string || 'priority_score';

        // Ensure direction is always a valid string
        const sortDir = search.sort_dir as string;
        this.currentSort.direction = (sortDir === 'asc' || sortDir === 'desc') ? sortDir : 'desc';

        this.page = parseInt(search.page as string) || 1;
        this.pageSize = parseInt(search.page_size as string) || this.pageSize;
        this.getPage();
    }

    override getPage (): void {
        this.paramService.setParams({
            page: this.page,
            page_size: this.pageSize,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
            search: this.search,
            type: this.activeTab,
        });
        this.getPages();
    }

    private async getPages (): Promise<void> {
        // Ensure currentSort has valid values
        if (!this.currentSort.direction || (this.currentSort.direction !== 'asc' && this.currentSort.direction !== 'desc')) {
            this.currentSort.direction = 'desc';
        }
        if (!this.currentSort.by) {
            this.currentSort.by = 'priority_score';
        }

        let params: any = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search || null,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
            notifications: true,
        };

        if (this.activeTab && this.activeTab !== 'all') {
            params['types[]'] = [this.activeTab];
        }

        params = this.updateParamsWithFilters(params);
        params = this.updateParamsWithIssuesFilters(params);

        try {
            this.promise = this.pageRepoService.getAll(params);
            const data = await this.promise;

            this.pages = data;
            this.createHeaderTranslation();
        } catch (error) {
            // Handle error
            this.pages = [];
        }
    }

    private createHeaderTranslation (): void {
        const totalPages = this.pages.total || 0;
        const params = {
            total: this.formatNumber(totalPages),
        };
        this.subheaderTranslation = this.translateService.getString(
            '[[total]] pages. Prioritize and fix all content issues across your website from one consolidated view.',
            params,
        );
    }

    private formatNumber (num: number): string {
        return num ? num.toLocaleString() : '0';
    }

    private updateParamsWithIssuesFilters (params: any): any {
        for (let i = 0; i < this.issues.length; i++) {
            params[this.issues[i].id] = true;
        }
        return params;
    }

    onFiltersChanges (changes: any): void {
        this.updateFilters(changes);
        if (changes.contains) {
            this.issues = changes.contains;
        }
        this.getPage();
    }

    private onDestroy (): void {
        if (this.eventId) {
            this.monEventsService.remove(this.eventId);
        }
        // No need to unsubscribe since we're using Promise instead of Observable
    }
}
